<template>
    <transition
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <cs-notification
            v-if="!!amsSearchStore.error"
            key="error-notification"
            data-component="ErrorNotification"
            class="mb-24 duration-300"
            :notificationState="Components.CsNotification.NotificationState.ERROR"
        >
            <template #headline> Technische Schwierigkeiten </template>
            <template #button>
                <cs-secondary-button
                    class="w-full screen-m:w-fit whitespace-nowrap shrink-0"
                    :isCentered="true"
                    :isSmall="true"
                    @click="reload"
                >
                    <span>Seite neu laden</span>
                </cs-secondary-button>
            </template>

            Die Autosuche steht dir gleich wieder zur Verfügung. Lade die Seite am besten gleich noch mal neu.
        </cs-notification>
    </transition>
</template>
<script lang="ts" setup>
import { useAmsSearchStore } from '../../../store/amsSearch'
import { CsNotification, CsSecondaryButton } from '@sunrise/components'
import { Components } from '@sunrise/types'

const amsSearchStore = useAmsSearchStore()

const reload = () => {
    window.location.reload()
}
</script>
